import { apiClient } from './api';
import { API_ENDPOINTS } from '../constants';

export const softwareService = {
  async getSoftware(filters) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.SOFTWARE}?${queryString}` : API_ENDPOINTS.SOFTWARE;
    
    const response = await apiClient.get(endpoint);
    
    // Extraer los datos de la respuesta estructurada
    if (response && response.success && response.data) {
      return response.data;
    }
    
    // Fallback: si la respuesta no tiene la estructura esperada, devolver la respuesta completa
    return response || [];
  },

  async getSoftwareById(id) {
    const response = await apiClient.get(API_ENDPOINTS.SOFTWARE_DETAIL(id));
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async createSoftware(data) {
    const response = await apiClient.post(API_ENDPOINTS.SOFTWARE, data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async updateSoftware(id, data) {
    const response = await apiClient.put(API_ENDPOINTS.SOFTWARE_DETAIL(id), data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async deleteSoftware(id) {
    return apiClient.delete(API_ENDPOINTS.SOFTWARE_DETAIL(id));
  },

  async registerSoftware(data) {
    const response = await apiClient.post(API_ENDPOINTS.SOFTWARE_REGISTER, data);
    
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async bulkUpdateSoftware(ids, updates) {
    return apiClient.patch(`${API_ENDPOINTS.SOFTWARE}bulk_update/`, {
      ids,
      updates,
    });
  },

  async exportSoftware(filters) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.SOFTWARE}export/?${queryString}` : `${API_ENDPOINTS.SOFTWARE}export/`;
    
    const response = await fetch(`${apiClient['baseURL']}${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${apiClient.getToken()}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to export software');
    }
    
    return response.blob();
  },
};